const albums2025 = [
  {
    id: 1,
    title: {
      english: "Gallery 2025",
      marathi: "गॅलरी २०२५"
    },
    year: 2025,
    photos: [
      {
        id: 1,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-1.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-1.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-1.jpg"
      },
      {
        id: 2,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-2.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-2.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-2.jpg"
      },
      {
        id: 3,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-3.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-3.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-3.jpg"
      },
      {
        id: 4,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-4.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-4.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-4.jpg"
      },
      {
        id: 5,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-5.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-5.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-5.jpg"
      },
      {
        id: 6,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-6.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-6.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-6.jpg"
      },
      {
        id: 7,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-7.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-7.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-7.jpg"
      },
      {
        id: 8,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-8.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-8.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-8.jpg"
      },
      {
        id: 9,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-9.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-9.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-9.jpg"
      },
      {
        id: 10,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-10.jpg"
      },
      {
        id: 11,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-11.jpg"
      },
      {
        id: 12,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-12.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-12.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-12.jpg"
      },
      {
        id: 13,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-13.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-13.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-13.jpg"
      },
      {
        id: 14,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-14.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-14.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-14.jpg"
      },
      {
        id: 15,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2025/2025-15.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2025/2025-15.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2025/2025-15.jpg"
      }
    ]
  }
];

export default albums2025;